import React from "react";
import { withStyles } from "@material-ui/core";
import constants from "../shared/constants";
import { CustomTooltip } from "components/CustomTooltip";
import { useTranslations } from "adapters/i18n";

function GoalPlanStatus({
  classes,
  active,
  initialDate,
  finalDate,
  situation,
}) {
  const { t } = useTranslations();
  const isActive = getStatus() === "Ativo";
  const isExpired = getStatus() === "Fora de vigência";
  const tooltipTitle = isExpiredOrInTheFuture();

  function isExpiredOrInTheFuture() {
    if (isExpired && new Date(finalDate) < new Date()) {
      return t("goalPlan:expired-info");
    }
    if (isExpired && new Date(initialDate) > new Date()) {
      return t("goalPlan:in-the-future-info");
    }
    return "";
  }

  function getStatus() {
    switch (situation) {
      case constants.situation.INACTIVE:
        return t("common:status.inactive");
      case constants.situation.PAST:
        return t("common:status.out-of-validity");
      case constants.situation.FUTURE:
        return t("common:status.out-of-validity");
      default:
        return t("common:status.active");
    }
  }

  return (
    <CustomTooltip
      title={tooltipTitle}
      placement="left"
      classes={{ tooltip: classes.tooltip }}
    >
      <div
        className={`${classes.container} ${
          isActive ? classes.activeBackground : classes.inactiveBackground
        }`}
      >
        <span
          className={isActive ? classes.activeStatus : classes.inactiveStatus}
        >
          {getStatus()}
        </span>
      </div>
    </CustomTooltip>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    maxWidth: "150px",
    borderRadius: "100px",
    padding: "6px 12px",
  },
  tooltip: {
    padding: 16,
    width: 200,
    fontSize: 14,
  },
  activeBackground: {
    backgroundColor: "#dff1df",
  },
  inactiveBackground: {
    backgroundColor: "#f8807833",
  },
  activeStatus: {
    color: "#4caf50",
    fontWeight: "550",
  },
  inactiveStatus: {
    textAlign: "center",
    color: "#f44336",
    fontWeight: "550",
  },
};

export default withStyles(styles)(GoalPlanStatus);
